import React from 'react';
import { Rect } from 'react-native-svg';
import { useTheme } from '../../hooks';
import AnimatedSvg from './AnimatedSvg';
export const Text = ({ lines = 1, width = '100%', height: overrideHeight, lineWidth = width, size = 'primary', gutter: passedGutter, backgroundColor, animate = true, ...props }) => {
    const theme = useTheme();
    const gutter = passedGutter ? passedGutter : theme.gutter[1];
    const fontSize = theme.fontSizes[size];
    const range = [...Array(lines).keys()];
    let height = (fontSize + gutter) * lines;
    if (overrideHeight) {
        height = overrideHeight;
    }
    return (React.createElement(AnimatedSvg, { width: width, height: height, backgroundColor: backgroundColor || theme.colors.skeletonLoader, animate: animate, ...props }, range.map((idx) => (React.createElement(Rect, { key: idx, x: "0", y: idx * (fontSize + gutter), rx: "2", ry: "2", width: lines > 1 && range.length - 1 === idx ? '75%' : lineWidth, height: fontSize })))));
};
//# sourceMappingURL=Text.js.map